'use client'

import {Card, Stack, Text, Title, Divider, Badge } from '@mantine/core';

import dynamic from 'next/dynamic';

const WebGpuUnsupportedPage = dynamic(
  () => import('../unsupported/unsupported'),
  { ssr: false, loading: () => <p>Support details...</p> }
);

type Props = {
  revision: string;
  service: string;
};

export default function SettingsPageClient({ revision, service}: Props ) 
{

  return (
    <main
      style={{
        minHeight: '100%',
        background: '#1f222b',
        padding: '24px',
        color: '#ebe6e6',
      }}
    >
      <Stack gap="lg" maw={720}>
        <div>
          <Title order={2} c="#ffffff">
            Settings
          </Title>
         
        </div>

        <Card
          radius="md"
          padding="lg"
          style={{
            background: '#23262f',
            border: '1px solid rgba(255,255,255,0.06)',
          }}
        >
          <Stack gap="md">
            <div>
              <Text size="sm" c="#b8b8b8">
                Current build
              </Text>
              <Badge
                mt={8}
                size="lg"
                variant="light"
                color="gray"
                styles={{
                  root: {
                    background: 'rgba(255,255,255,0.06)',
                    color: '#ffffff',
                    textTransform: 'none',
                  },
                }}
              >
                {revision}
              </Badge>
            </div>

          </Stack>
        </Card>
      </Stack>
      <Stack gap="md">
      <WebGpuUnsupportedPage/>
      </Stack>
    </main>
  );
}

